<template>
  <div class="merch-products-item-image">
    <img v-if="image" :src="image" alt="product">
    <img v-else src="@/assets/empty.png" alt="product">
  </div>
  <div class="merch-products-item-info">
    <span class="merch-products-item-name">{{ name }}</span>
    <span v-if="!idDiscounted" class="merch-products-item-price">€ {{ price }}</span>
    <div v-else class="merch-products-item-discounted-price">
      <span class="merch-products-item-price discounted">€ {{ price }}</span>
      <span class="merch-products-item-price">€ {{ discountedPrice }}</span>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';

export default {
  props: {
    merch: Object,
  },
  setup(props) {
    const name = ref('');
    const price = ref(0);
    const discountedPrice = ref(null);
    const image = ref('');

    const idDiscounted = computed(() => discountedPrice.value !== null);

    onMounted(() => {
      name.value = decodeURIComponent(props?.merch?.locs[0]?.name) ?? '';
      price.value = props?.merch?.price?.toFixed(2) ?? 0.00;
      discountedPrice.value = props?.merch?.discountedPrice?.toFixed(2) ?? null;
      //  image.value = props?.merch?.images[0]?.base64 ?? null;
      image.value = props?.merch?.image ?? null;
      if (image.value != null) {
        image.value = process.env.VUE_APP_IMAGE_URL + image.value;
      }
    });

    return {
      name,
      price,
      discountedPrice,
      image,
      idDiscounted,
    };
  },
};
</script>
